import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import {
  MaxShipping,
  RegularBenefitVariant,
} from '../../../../../../../typings'
import { validationShippingVariantSuite } from '../../../../../../ShippingVariantSelector/validation'
import { messages } from './messages'

export function validationSuiteMaxShipping(intl: IntlShape) {
  return create((props: MaxShipping) => {
    const { value, type } = props
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.MaxShipping, () => {
      omitWhen(value === undefined, () => {
        test('value', $t(validation.greaterThan, { value: 0 }), () => {
          enforce(value).greaterThan(0)
        })
      })

      test('value', $t(validation.required), () => {
        enforce(value).isNotEmpty()
      })

      validationShippingVariantSuite(intl)(props as MaxShipping)
    })
  })
}
